import React, { useEffect, useRef } from "react";

const LazyLoadImage = ({ dSrc, alt, className }) => {
    const imgRef = useRef();

    useEffect(() => {
        const imgElement = imgRef.current;

        // Function to handle the lazy loading
        const lazyLoad = (entries, observer) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    const img = entry.target;
                    // Set the actual `src` from `dSrc`
                    img.src = dSrc;
                    img.classList.add("loaded");
                    observer.unobserve(img);
                    // Error handling
                    img.onerror = () => {
                        img.src = "images/loader.gif"; // Fallback image
                    };
                }
            });
        };

        // Create an IntersectionObserver
        const observer = new IntersectionObserver(lazyLoad);
        if (imgElement) {
            observer.observe(imgElement);
        }

        // Cleanup function
        return () => {
            if (imgElement) {
                observer.unobserve(imgElement);
            }
        };
    }, [dSrc]);

    return (
        <img
            ref={imgRef}
            data-src={dSrc} // This is a placeholder until it's loaded
            alt={alt}
            src="images/loader.gif"
            className={className}
        />
    );
};

export default LazyLoadImage;
